<template>
  <vx-card title="Import Promotion">
    <vs-tabs>

      <vs-tab label="Promotion">
        <div class="tab-text">
          <promotion></promotion>
        </div>
      </vs-tab>
    </vs-tabs>
  </vx-card>
</template>
<script>
import Promotion from "./promotion";
export default {
  components: {
    Promotion
  }
};
</script>